"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangeInput = DateRangeInput;

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

require("react-dates/initialize");

var _reactDates = require("react-dates");

var _fieldError = require("../field-error");

var _fieldsStyledComponents = require("../fields-styled-components");

var _media = require("react-components/media");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _typographyStyles = require("../../typography/typography-styles");

var _reactForms = require("@seegno/react-forms");

var _react = _interopRequireWildcard(require("react"));

var _datepicker = _interopRequireDefault(require("react-dates/lib/css/_datepicker.css"));

var _moment = _interopRequireDefault(require("moment"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var calendarIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><g fill=\"none\" stroke=\"currentColor\" stroke-width=\".963\"><path d=\"M10.7 4h10.6c4.3 0 7.7 3.4 7.7 7.7v8.7c0 4.3-3.4 7.7-7.7 7.7H10.7C6.4 28 3 24.6 3 20.3v-8.7C3 7.4 6.4 4 10.7 4z\"/><path d=\"M8.8 12.6h1c1.1 0 1.9.9 1.9 1.9v1c0 1.1-.9 1.9-1.9 1.9h-1c-1.1 0-1.9-.9-1.9-1.9v-1c0-1 .8-1.9 1.9-1.9zm0 6.8h1c1.1 0 1.9.9 1.9 1.9v1c0 1.1-.9 1.9-1.9 1.9h-1c-1.1 0-1.9-.9-1.9-1.9v-1c0-1.1.8-1.9 1.9-1.9zm6.7-6.8h1c1.1 0 1.9.9 1.9 1.9v1c0 1.1-.9 1.9-1.9 1.9h-1c-1.1 0-1.9-.9-1.9-1.9v-1c0-1 .9-1.9 1.9-1.9zm0 6.8h1c1.1 0 1.9.9 1.9 1.9v1c0 1.1-.9 1.9-1.9 1.9h-1c-1.1 0-1.9-.9-1.9-1.9v-1c0-1.1.9-1.9 1.9-1.9zm6.8-6.8h1c1.1 0 1.9.9 1.9 1.9v1c0 1.1-.9 1.9-1.9 1.9h-1c-1.1 0-1.9-.9-1.9-1.9v-1c-.1-1 .8-1.9 1.9-1.9zm0 6.8h1c1.1 0 1.9.9 1.9 1.9v1c0 1.1-.9 1.9-1.9 1.9h-1c-1.1 0-1.9-.9-1.9-1.9v-1c-.1-1.1.8-1.9 1.9-1.9zM3.5 9.3h25\"/></g></svg>";

/**
 * `StyledFormControlWrapper` styled component.
 */
var StyledFormControlWrapper = (0, _styledComponents["default"])(_fieldsStyledComponents.FormControlWrapper).withConfig({
  displayName: "date-range-input__StyledFormControlWrapper",
  componentId: "sc-1kzgquh-0"
})(["align-items:initial;column-gap:initial;display:block;"]);
/**
 * `DateRangePickerWrapper` styled component.
 */

var DateRangePickerWrapper = _styledComponents["default"].div.withConfig({
  displayName: "date-range-input__DateRangePickerWrapper",
  componentId: "sc-1kzgquh-1"
})(["", " height:50px;position:relative;", " .DateRangePicker{height:100%;width:100%;> div{height:100%;}&Input{align-items:center;background-color:transparent;display:grid;grid-column-gap:8px;grid-template-columns:", " max-content minmax(", ",1fr) max-content;height:100%;padding:0 10px 0 20px;", " &_calendarIcon{border-radius:50%;grid-column:-1;height:40px;margin:0;padding:8px;transition:background-color ", ";width:40px;&:focus,&:hover{background-color:", ";}}&_arrow{color:", ";transition:color ", ";", "}}&_picker{border-radius:12px;z-index:", ";.CalendarDay{&__default{transition:", ";transition-property:background-color,border-color,color;&:focus,&:hover{background-color:", ";border-color:", ";color:", ";}}&__hovered{&_span{&,&:focus,&:hover{background-color:", ";border-color:", ";color:", ";}}}&__selected{transition:", ";transition-property:background-color,border-color,color;&,&:active{background-color:", ";border-color:", ";color:", ";}&:hover{background-color:", ";border-color:", ";}&_span{background-color:", ";border-color:", ";color:", ";}}}.CalendarMonth_caption{padding-bottom:42px;}}}.DateInput{background:transparent;width:100%;&_input{", " background-color:transparent;border:none;color:", ";padding:8px 0;transition:color ", ";&__disabled{color:", ";font-style:initial;}&::-webkit-input-placeholder{color:", ";font-size:inherit;font-weight:inherit;line-height:inherit;", "}}&_fang{top:46px !important;z-index:", ";}}.DayPicker{border-radius:12px;&_transitionContainer{border-radius:12px;}}"], _datepicker["default"], _styles.media.min('md')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: 54px;\n  "]))), (0, _styledTools.prop)('columnSize'), (0, _styledTools.prop)('columnSize'), (0, _styledTools.ifProp)('hasStartDateValue', (0, _styledComponents.css)(["grid-template-columns:85px max-content minmax(85px,1fr) max-content;"])), (0, _styledTools.theme)('transitions.defaultTransition'), (0, _styles.color)('gray300'), (0, _styles.color)('gray500'), (0, _styledTools.theme)('transitions.defaultTransition'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))), (0, _styledTools.theme)('zIndex.dateRangeInput.picker'), (0, _styledTools.theme)('transitions.defaultTransition'), (0, _styles.color)('gray300'), (0, _styles.color)('gray300'), (0, _styles.color)('secondary'), (0, _styles.color)('gray300'), (0, _styles.color)('gray300'), (0, _styles.color)('secondary'), (0, _styledTools.theme)('transitions.defaultTransition'), (0, _styles.color)('gray400'), (0, _styles.color)('gray400'), (0, _styles.color)('secondary'), (0, _styles.color)('gray300'), (0, _styles.color)('gray300'), (0, _styles.color)('gray400'), (0, _styles.color)('gray400'), (0, _styles.color)('secondary'), _typographyStyles.typography.styles.textNormal, (0, _styles.color)('secondary'), (0, _styledTools.theme)('transitions.defaultTransition'), (0, _styles.color)('gray400'), (0, _styles.color)('gray500'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))), (0, _styledTools.theme)('zIndez.dateRangeInput.fang'));
/**
 * `StyledIcon` styled component.
 */


var StyledIcon = (0, _styledComponents["default"])(_media.Icon).withConfig({
  displayName: "date-range-input__StyledIcon",
  componentId: "sc-1kzgquh-2"
})(["transition:color ", ";", ""], (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["color:", ";"], (0, _styles.color)('gray400'))));
/**
 * Export `DateRangeInput` component.
 */

function DateRangeInput(props) {
  var _props$customArrowIco = props.customArrowIcon,
      customArrowIcon = _props$customArrowIco === void 0 ? '-' : _props$customArrowIco,
      disabled = props.disabled,
      endDateName = props.endDateName,
      endDatePlaceholder = props.endDatePlaceholder,
      columnSize = props.columnSize,
      _props$maxDate = props.maxDate,
      maxDate = _props$maxDate === void 0 ? (0, _moment["default"])().startOf('date').add(1, 'd') : _props$maxDate,
      minDate = props.minDate,
      name = props.name,
      startDateName = props.startDateName,
      startDatePlaceholder = props.startDatePlaceholder;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      focusedInput = _useState2[0],
      setFocusedInput = _useState2[1];

  var _useField = (0, _reactForms.useField)(endDateName),
      endDateError = _useField.error,
      endDateMeta = _useField.meta,
      onBlurEndDate = _useField.onBlur,
      onChangeEndDate = _useField.onChange,
      onFocusEndDate = _useField.onFocus,
      endDate = _useField.value;

  var _useField2 = (0, _reactForms.useField)(startDateName),
      startDateError = _useField2.error,
      startDateMeta = _useField2.meta,
      onBlurStartDate = _useField2.onBlur,
      onChangeStartDate = _useField2.onChange,
      onFocusStartDate = _useField2.onFocus,
      startDate = _useField2.value;

  var hasError = !!endDateError && (endDateMeta === null || endDateMeta === void 0 ? void 0 : endDateMeta.touched) || !!startDateError && (startDateMeta === null || startDateMeta === void 0 ? void 0 : startDateMeta.touched);
  var hasFocus = (endDateMeta === null || endDateMeta === void 0 ? void 0 : endDateMeta.active) || (startDateMeta === null || startDateMeta === void 0 ? void 0 : startDateMeta.active);

  var displayFormat = _moment["default"].localeData().longDateFormat('L');

  var handleFocusChange = (0, _react.useCallback)(function (values) {
    if (!(0, _isEmpty2["default"])(values)) {
      setFocusedInput(values);
      onFocusEndDate();
      onFocusStartDate();
      return;
    }

    setFocusedInput(null);
    onBlurEndDate();
    onBlurStartDate();
  }, [onBlurEndDate, onBlurStartDate, onFocusEndDate, onFocusStartDate]);
  return /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormGroup, {
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(StyledFormControlWrapper, {
    disabled: disabled,
    hasError: hasError,
    hasFocus: hasFocus
  }, /*#__PURE__*/_react["default"].createElement(DateRangePickerWrapper, {
    columnSize: columnSize,
    disabled: disabled,
    hasStartDateValue: !(0, _isNil2["default"])(startDate)
  }, /*#__PURE__*/_react["default"].createElement(_reactDates.DateRangePicker, {
    customArrowIcon: customArrowIcon,
    customInputIcon: /*#__PURE__*/_react["default"].createElement(StyledIcon, {
      "aria-hidden": true,
      color: (0, _styles.color)('gray500'),
      disabled: disabled,
      icon: calendarIcon,
      size: '24px'
    }),
    disabled: disabled,
    displayFormat: displayFormat,
    endDate: (0, _isNil2["default"])(endDate) ? undefined : (0, _moment["default"])(endDate, displayFormat),
    endDateId: endDateName,
    endDatePlaceholderText: endDatePlaceholder,
    focusedInput: focusedInput,
    hideKeyboardShortcutsPanel: true,
    inputIconPosition: 'after',
    isOutsideRange: function isOutsideRange(date) {
      return date.isSameOrAfter(maxDate);
    },
    maxDate: maxDate,
    minDate: minDate,
    noBorder: true,
    numberOfMonths: 1,
    onDatesChange: function onDatesChange(_ref) {
      var endDate = _ref.endDate,
          startDate = _ref.startDate;
      onChangeStartDate((0, _isNil2["default"])(startDate) ? undefined : (0, _moment["default"])(startDate).format(displayFormat));
      onChangeEndDate((0, _isNil2["default"])(endDate) ? undefined : (0, _moment["default"])(endDate).format(displayFormat));
    },
    onFocusChange: handleFocusChange,
    startDate: (0, _isNil2["default"])(startDate) ? undefined : (0, _moment["default"])(startDate, displayFormat),
    startDateId: startDateName,
    startDatePlaceholderText: startDatePlaceholder
  }))), /*#__PURE__*/_react["default"].createElement(_fieldError.FieldError, {
    error: endDateError || startDateError,
    isOpen: !!endDateError || !!startDateError,
    name: name
  }));
}